import Store from '../../helpers/store';

export default class BacteriaStore extends Store {
}


// WEBPACK FOOTER //
// ./js/models/bacteria/bacteriaStore.js